// extracted by mini-css-extract-plugin
export default {"link":"Link-index__link--mYm3y"};